import { render, staticRenderFns } from "./ResourceGrid.vue?vue&type=template&id=32d4bb22&scoped=true&"
import script from "./ResourceGrid.vue?vue&type=script&lang=js&"
export * from "./ResourceGrid.vue?vue&type=script&lang=js&"
import style0 from "./ResourceGrid.vue?vue&type=style&index=0&id=32d4bb22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4bb22",
  null
  
)

export default component.exports